// Copyright (c) Jonathan Ferraz.
// Licensed under the MIT license.

import { Fragment, ReactNode } from 'react';

import { FixedFooter } from 'components/FixedFooter/FixedFooter';

import { Container } from './styles';

import { Header } from '..';

interface LayoutProps {
  children: ReactNode;
  noPadding?: boolean;
}

export const Layout = ({ children, noPadding }: LayoutProps) => {
  return (
    <Fragment>
      <Header />
      <Container noPadding={noPadding}>
        {children}
        {window.location.pathname === '/' ? <FixedFooter /> : undefined}
      </Container>
    </Fragment>
  );
};
